import { render } from "./ModalInformativoPep.vue?vue&type=template&id=131321c6"
import script from "./ModalInformativoPep.vue?vue&type=script&lang=js"
export * from "./ModalInformativoPep.vue?vue&type=script&lang=js"

import "./ModalInformativoPep.vue?vue&type=style&index=0&id=131321c6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__